import React, { useState, useRef } from "react";
import SvgIcon from "../SvgIcon";
import { getMinutesAndHours } from "../../utils/converters/time-helper";
import useClickOutside from "../../hooks/useClickOutside";
import { parseTime } from "../../views/athlete-portal/calendar/sleep-time/SleepTime";
import PropTypes from "prop-types";

const SleepInput = ({ defaultValue, name, notAbleToEdit, setSleepTime }) => {
  const dropdownRef = useRef(null);

  const [defaultHours, defaultMinutes] = getMinutesAndHours(defaultValue);

  const [isListOpen, setIsListOpen] = useState(false);
  const [hours, setHours] = useState(defaultHours);
  const [minutes, setMinutes] = useState(defaultMinutes);

  useClickOutside(
    dropdownRef,
    () => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsListOpen(false);
      }
    },
    isListOpen
  );

  const handleHoursChange = (value) => {
    if (value === "") {
      setHours("");
      setSleepTime("");
      return;
    }

    let newHours = parseInt(value, 10);

    if (!isNaN(newHours) && newHours >= 0) {
      setHours(newHours);
      setSleepTime(String((newHours * 60 + minutes) * 60 * 1000));
    }
  };

  const handleMinutesChange = (value) => {
    if (value === "") {
      setMinutes("");
      setSleepTime("");
      return;
    }

    let newMinutes = parseInt(value, 10);

    if (!isNaN(newMinutes) && newMinutes >= 0 && newMinutes < 60) {
      setMinutes(newMinutes);
      setSleepTime(String((hours * 60 + newMinutes) * 60 * 1000));
    }
  };

  const toggleList = (e) => {
    if (!notAbleToEdit) {
      e.preventDefault();
      setIsListOpen((prevState) => !prevState);
    }
  };

  return (
    <details
      ref={dropdownRef}
      className={
        notAbleToEdit
          ? "disabled-time-input min-and-secs-input"
          : "min-and-secs-input"
      }
      role="list"
      open
    >
      <summary onClick={toggleList}>
        {hours || minutes
          ? parseTime((hours * 60 + minutes) * 60 * 1000 || 0)
          : "-"}
        <SvgIcon
          src={isListOpen ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
        />
      </summary>
      <div className={isListOpen ? "opened" : ""}>
        <div className="label-row">
          <label htmlFor="default-time-hours">Hr</label>
          <label htmlFor="default-time-minutes">Min</label>
        </div>
        <div className="input-row">
          <input
            autoFocus={true}
            disabled={notAbleToEdit}
            className={`default-time-select-input ${
              hours === 0 ? "zero-value" : ""
            }`}
            type="number"
            id="default-time-hours"
            name={`timeHours${name}`}
            min="0"
            value={hours}
            onChange={(e) => {
              handleHoursChange(e.target.value);
            }}
            maxLength={2}
            onFocus={(e) => {
              if (e.target.value === "0") {
                e.target.value = "";
              }
            }}
            onBlur={(e) => {
              if (e.target.value === "") {
                e.target.value = "0";
              }
            }}
            sz="large"
          />
          <span className="time-separator">:</span>
          <input
            disabled={notAbleToEdit}
            className={`default-time-select-input ${
              minutes === 0 ? "zero-value" : ""
            }`}
            type="number"
            id="default-time-minutes"
            name={`timeMinutes${name}`}
            min="0"
            max="59"
            value={minutes}
            onChange={(e) => {
              handleMinutesChange(e.target.value);
            }}
            maxLength={2}
            onFocus={(e) => {
              if (e.target.value === "0") {
                e.target.value = "";
              }
            }}
            onBlur={(e) => {
              if (e.target.value === "") {
                e.target.value = "0";
              }
            }}
            sz="large"
          />
        </div>
      </div>
    </details>
  );
};

SleepInput.propTypes = {
  defaultValue: PropTypes.any,
  name: PropTypes.string,
  notAbleToEdit: PropTypes.bool,
  setSleepTime: PropTypes.any,
};

export default SleepInput;
